export default __webpack_public_path__ + "static/media/HelveticaNowDisplay-LightIta.19ffeb57.ttf";